export const isTruthy = (x: any): boolean => !!x;
